import { Component } from '@angular/core';

@Component({
    selector: 'upp-application-page',
    templateUrl: './upp-page.html',
    styleUrls: ['./upp-page.scss'],
})
export class UppApplicationPageComponent {
    // nothing to do
}
